import React, { useEffect, useState } from "react";
import { api } from "../api";

export default function CertificateVerifyPage({ code }) {
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get(`/api/certificates/${code}`)
      .then(setResult)
      .catch(() => setError("not-found"));
  }, [code]);

  return (
    <div className="page page-narrow">
      <div className="auth-card" style={{ textAlign: "center" }}>
        <h1>Certificate verification</h1>
        {error && (
          <div className="alert alert-error">
            No certificate found for code <code>{code}</code>.
          </div>
        )}
        {result && result.valid && (
          <>
            <div className="success-check">&#10003;</div>
            <p>
              <strong>{result.studentName}</strong> completed
            </p>
            <h2>{result.courseTitle}</h2>
            <p className="muted">Issued {new Date(result.issuedAt).toLocaleDateString()}</p>
            <p className="muted">Certificate ID: {result.code}</p>
            <a className="btn btn-primary btn-block" href={`/api/certificates/${code}/download`}>
              Download PDF
            </a>
          </>
        )}
        {result && !result.valid && (
          <div className="alert alert-error">This certificate has been revoked.</div>
        )}
      </div>
    </div>
  );
}
